import { Component, inject } from '@angular/core';
import { IconComponent, PopUpService } from 'vis-ods-angular';
import { MockSettingsPopupComponent } from '../../app/shared/components/pop-ups/mock-settings-popup/mock-settings-popup.component';
import { BehaviorSubject } from 'rxjs';
import { NgIf } from '@angular/common';
import { MOCK_STORAGE } from '../mock-switch/mock-switch.component';
import { OEEnvironment } from 'src/environments/environment.type';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-mock-values',
	templateUrl: './mock-values.component.html',
	imports: [NgIf, IconComponent],
})
export class MockValuesComponent {
	private mockStorage = inject(MOCK_STORAGE);
	mockMode = this.mockStorage.value()?.mockMode;
	isDev = environment.appMeta.env === OEEnvironment.DEV;
	private readonly popUpService = inject(PopUpService);

	openMockValuesPopup() {
		this.popUpService.openDrawer(MockSettingsPopupComponent, {
			data: {
				headline: 'Edit mock values',
			},
			enableCloseButton: new BehaviorSubject(true),
		});
	}
}
